export default {
  NEW_CONTEST_GETdENTERlIST: '/api/v3/contest/contest/getCenterList',     // 活动中心(学生端)

  NEW_CONTEST_LIST: '/api/v3/contest/contest/list',         // 查询首页活动列表(学生端)

  NEW_CONTEST_DETAIL_GET: '/api/v3/contest/detail/user/get',          // 查询详情页内容

  NEW_CONTEST_DETAIL_RELATION_LIST: '/api/v3/contest/detail/user/relation/list',       // 查询详情页分类列表

  NEW_CONTEST_SEASON_GETINFO: '/api/v3/contest/season/getInfo',       // 查询活动季信息

  NEW_CONTEST_USER_GETBASEINFO: '/api/v3/contest/taskRelation/user/getBaseInfo',    // 查询任务详情

  NEW_CONTEST_TASKRELATION_USER_DONETASK: '/api/v3/contest/taskRelation/user/doneTask',     // 完成任务(学生端)

  NEW_CONTEST_TASKRELATION_USER_GETTASKCARDLIST: '/api/v3/contest/taskRelation/user/getTaskCardList',     // 查询用户任务卡列表(学生端)

  NEW_CONTEST_TASKRELATION_USER_GETSUBTASKLIST: '/api/v3/contest/taskRelation/user/getSubtaskList',      // 查询子任务列表(学生端)

  NEW_CONTEST_TASKRELATION_VALIDATE: '/api/v3/contest/taskRelation/validate',     // 校验任务权限(学生端)

  NEW_CONTEST_TASKRELATION_USER_GETEXTRAJSON: '/api/v3/contest/taskRelation/user/getExtraJson',    // 获取是否跳转缴费

  NEW_CONTEST_EQUIPMENT_GETINFO: '/api/v3/contest/test/equipment/getInfo',    // 获取设备调试信息（学生端）

  NEW_CONTEST_EQUIPMENT_SUBMITRESULT: '/api/v3/contest/test/equipment/submitResult',     // 提交检查项结果（学生端）
  
  NEW_GROUP_USER_GETINFO: '/api/v3/contest/group/user/getInfo',    // 查询组别信息(学生端)

  NEW_GROUP_USER_SUBMIT: '/api/v3/contest/group/user/submit',       // 学生选择组别(学生端)

  NEW_CONTEST_REMINDER: '/api/v3/contest/contest/reminder',    // 查询某些活动是否正在进行中

  NEW_TASKRELATION_GETMODE: '/api/v3/contest/taskRelation/getExperienceMode'    // 是否是体验模式 1是 0否
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/newActivity.js